var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoti({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 17.5H8.33339M15.0001 6.66666C15.0001 5.34058 14.4733 4.06881 13.5356 3.13113C12.5979 2.19345 11.3261 1.66666 10.0001 1.66666C8.67397 1.66666 7.4022 2.19345 6.46452 3.13113C5.52684 4.06881 5.00006 5.34058 5.00006 6.66666C5.00006 9.24182 4.35045 11.005 3.62478 12.1712C3.01266 13.1549 2.7066 13.6468 2.71783 13.784C2.73025 13.9359 2.76244 13.9938 2.88487 14.0846C2.99544 14.1667 3.49388 14.1667 4.49077 14.1667H15.5093C16.5062 14.1667 17.0047 14.1667 17.1152 14.0846C17.2377 13.9938 17.2699 13.9359 17.2823 13.784C17.2935 13.6468 16.9875 13.1549 16.3753 12.1712C15.6497 11.005 15.0001 9.24182 15.0001 6.66666Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoti);
export default __webpack_public_path__ + "static/media/noti.050438ae.svg";
export { ForwardRef as ReactComponent };